import foreground1 from '#/assets/home/foreground-image1.webp'
import foreground2 from '#/assets/home/foreground-image2.webp'
import foreground3 from '#/assets/home/foreground-image3.webp'
import foreground4 from '#/assets/home/foreground-image4.webp'

export const TEACHERS_CONTENT = {
  eyebrow: 'MEET OUR TEAM',
  title: 'Learn From',
  highlight: 'World-Class Scholars',
  description:
    'Our handpicked teachers bring decades of combined experience, verified Ijazahs, and a genuine love for sharing the sacred knowledge of the Quran.',
}

export const TEACHERS = [
  {
    name: 'Sheikh Abdullah Al-Masri',
    role: 'Quran Memorization & Tajweed',
    bio: 'Ijazah holder in Hafs recitation with 14 years of online teaching experience across 30+ countries.',
    image: foreground2,
    imageAlt: 'Sheikh Abdullah Al-Masri',
    specialties: ['Hifz', 'Tajweed', 'Ijazah'],
  },
  {
    name: 'Ustadha Fatima Al-Rashid',
    role: 'Female Quran Tutor',
    bio: 'Specialized in teaching children and sisters with a gentle, patient approach and proven results.',
    image: foreground1,
    imageAlt: 'Ustadha Fatima Al-Rashid',
    specialties: ['Quran for Sisters', 'Kids Program', 'Noorani Qaida'],
  },
  {
    name: 'Sheikh Yusuf Al-Karim',
    role: 'Arabic & Islamic Studies',
    bio: 'Graduate of Al-Azhar University with a deep mastery of Quranic Arabic, Fiqh, and Islamic sciences.',
    image: foreground3,
    imageAlt: 'Sheikh Yusuf Al-Karim',
    specialties: ['Arabic', 'Islamic Studies', 'Fiqh'],
  },
  {
    name: 'Ustadh Omar Al-Farouqi',
    role: 'Advanced Recitation & Ijazah',
    bio: "Certified in multiple Qira'at with a chain of transmission to the great scholars of Egypt and Saudi Arabia.",
    image: foreground4,
    imageAlt: 'Ustadh Omar Al-Farouqi',
    specialties: ["Qira'at", 'Ijazah Path', 'Tajweed Mastery'],
  },
]
